import { CaseInfoBannerKey, CaseLandingViewProps } from "src/pages/case-landing/case-landing-view-model";
import { PortalState } from "src/api/types/enums";

type NoRedressDecisionViewProps = CaseLandingViewProps & {
  canChallenge: boolean;
};

export function useNoRedressDecisionViewProps(state: PortalState): NoRedressDecisionViewProps {
  switch (state) {
    case PortalState.NoRedressStart: {
      return {
        bannerKey: CaseInfoBannerKey.DecisionIssued,
        canChallenge: true
      };
    }
    case PortalState.NoRedressFinal: {
      return {
        bannerKey: CaseInfoBannerKey.DecisionIssued,
        canChallenge: false,
      };
    }
    default:
      return {
        bannerKey: CaseInfoBannerKey.DecisionIssued,
        canChallenge: true,
      };
  }
}